import { normalizeRemoteAssetExpiresAt } from "./remoteAssetExpiry";

const CACHE_KEY = "companyLogoCache";
const DEFAULT_TTL_MS = 24 * 60 * 60 * 1000;

function safeParse(raw) {
  if (!raw) return {};
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

export function readCachedCompanyLogo(companyId) {
  if (!companyId && companyId !== 0) return null;
  const raw = localStorage.getItem(CACHE_KEY);
  const store = safeParse(raw);
  const entry = store[String(companyId)];
  if (!entry || !entry.logoUrl) return null;

  const now = Date.now();
  const expiresAt = normalizeRemoteAssetExpiresAt(entry.logoUrlExpiresAt) || 0;
  const savedAt = Number(entry.savedAt || 0);
  const ttl = savedAt ? savedAt + DEFAULT_TTL_MS : 0;
  const isValid = (expiresAt && now < expiresAt) || (ttl && now < ttl);
  return isValid ? entry : null;
}

export function writeCachedCompanyLogo(companyId, logoInfo) {
  if (!companyId && companyId !== 0) return;
  if (!logoInfo || !logoInfo.logoUrl) return;

  const raw = localStorage.getItem(CACHE_KEY);
  const store = safeParse(raw);
  store[String(companyId)] = {
    logoUrl: logoInfo.logoUrl,
    logoUrlExpiresAt: normalizeRemoteAssetExpiresAt(logoInfo.logoUrlExpiresAt),
    savedAt: Date.now(),
  };
  localStorage.setItem(CACHE_KEY, JSON.stringify(store));
}

